import React, { useEffect, useState } from "react";
import { makeStyles, Container, Grid } from "@material-ui/core";
import AThirdBanner from "../../../components/MainComponent/SecondSectionComponent/LhrsDividedComponent/AThirdBanner";
import TwoThirdNotice from "../../../components/MainComponent/SecondSectionComponent/LhrsDividedComponent/TwoThirdNotice";
import TwoSecondWebtoon from "../../../components/MainComponent/SecondSectionComponent/LhrsDividedComponent/TwoSecondWebtoon";
import ThreeThirdVideo from "../../../components/MainComponent/SecondSectionComponent/LhrsDividedComponent/ThreeThirdVideo";
import TwoSecondCompetition from "../../../components/MainComponent/SecondSectionComponent/LhrsDividedComponent/TwoSecondCompetition";
import { GET_SUB_PAGE_INFO } from "../../../quries/material";
import { useQuery } from "@apollo/client";
import ArchivePageComponent from "../../../components/MainComponent/ArchivePageComponent";

const useStyles = makeStyles((theme) => ({}));

interface ArchivePageSectionProps {
  match: any;
  location: any;
  history: any;
}

function ArchivePageSection({
  match,
  location,
  history,
}: ArchivePageSectionProps) {
  const classes = useStyles();

  const { data, loading, error } = useQuery(GET_SUB_PAGE_INFO, {
    fetchPolicy: "no-cache",

    variables: {
      where: {
        route_slug: `${match.params.sub_page_slug}`,
      },
    },
  });

  const [subProgram, setSubProgram] = useState<any>(null);

  useEffect(() => {
    if (data && data.archiveSubCategories) {
      setSubProgram(data.archiveSubCategories[0]);
    }
  }, [data]);

  if (loading) return null;
  if (data === undefined) return null;
  if (error || !data.archiveSubCategories) {
    console.log(error);
  }

  return (
    <Container maxWidth={"xl"} disableGutters style={{}}>
      <Grid
        xs={12}
        item
        container
        justify="center"
        style={
          {
            // paddingTop: "4rem",
            // margin: " 0 -15px",
          }
        }
      >
        {subProgram ? (
          <ArchivePageComponent rowData={subProgram} match={match} />
        ) : (
          <div></div>
        )}
      </Grid>
    </Container>
  );
}

// export default MainContainer;
export default ArchivePageSection;
